(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.machuB2BBulkOrder) return;
  window.machuB2BBulkOrder = true;
  let busy = false;
  let uncertain = false;
  const cards = () => Array.from(document.querySelectorAll('[data-b2b-card]'));
  const bars = () => Array.from(document.querySelectorAll('[data-b2b-order-bar]'));
  const message = text => document.querySelectorAll('#b2b-order-panel [data-b2b-status]').forEach(status => { status.textContent = text; });
  function presetValues(card) {
    const option = card.querySelector('[data-b2b-variant]')?.selectedOptions[0];
    const format = (option?.textContent || '').split('–')[0].trim().toLowerCase();
    if (/\b(karte|karten|postcard|postcards)\b/.test(format)) return [9, 18, 25];
    if (/\b(poster|posters)\b/.test(format)) return [3, 6, 9];
    return [];
  }
  function presetGroup(values, title) {
    const group = document.createElement('div');
    group.className = 'b2b-presets';
    group.dataset.b2bPresets = values.join(',');
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', 'Mengenvorwahl für ' + title);
    values.forEach(quantity => {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.b2bPreset = String(quantity);
      button.textContent = String(quantity);
      button.setAttribute('aria-label', quantity + ' Stück auswählen');
      button.setAttribute('aria-pressed', 'false');
      group.appendChild(button);
    });
    return group;
  }
  function refreshPresets() {
    cards().forEach(card => {
      const input = card.querySelector('[data-b2b-quantity]');
      if (!input) return;
      const values = presetValues(card);
      let group = card.querySelector('[data-b2b-presets]');
      if (group && group.dataset.b2bPresets !== values.join(',')) { group.remove(); group = null; }
      if (!group && values.length) {
        group = presetGroup(values, card.dataset.title);
        input.closest('label').before(group);
      }
    });
    document.querySelectorAll('[data-b2b-presets]').forEach(group => {
      const scope = group.closest('[data-b2b-card]') || group.closest('li');
      const input = scope?.querySelector('[data-b2b-quantity], [data-b2b-review-quantity]');
      group.querySelectorAll('button').forEach(button => {
        button.disabled = busy || !input || input.disabled;
        button.setAttribute('aria-pressed', String(Boolean(input && input.value !== '' && Number(input.value) === Number(button.dataset.b2bPreset))));
      });
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-b2b-preset]');
    if (!button || button.disabled || busy) return;
    const scope = button.closest('[data-b2b-card]') || button.closest('li');
    const input = scope?.querySelector('[data-b2b-quantity], [data-b2b-review-quantity]');
    if (!input || input.disabled) return;
    input.value = button.dataset.b2bPreset;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  function mountFeed() {
    const sections = Array.from(document.querySelectorAll('[data-b2b-catalog]'));
    sections.forEach((section, index) => section.classList.toggle('b2b-catalog-first', index === 0));
    let panel = document.getElementById('b2b-order-panel');
    const template = document.querySelector('template[data-b2b-order-template]');
    if (!sections.length || !template) {
      if (panel) panel.remove();
      document.body.classList.remove('machu-b2b-feed');
      return;
    }
    if (!panel) {
      document.body.appendChild(template.content.cloneNode(true));
      panel = document.getElementById('b2b-order-panel');
      panel.querySelector('dialog').addEventListener('cancel', event => { if (busy) event.preventDefault(); });
    }
    document.body.classList.add('machu-b2b-feed');
  }
  function selectionRows() {
    const result = new Map();
    cards().forEach(card => {
      const input = card.querySelector('[data-b2b-quantity]');
      const select = card.querySelector('[data-b2b-variant]');
      const quantity = input ? Number(input.value) : 0;
      if (!Number.isSafeInteger(quantity) || quantity <= 0 || !select) return;
      const option = select.selectedOptions[0];
      if (!option || option.disabled) return;
      let row = result.get(select.value);
      if (!row) {
        const image = card.closest('article').querySelector('img');
        row = { id: select.value, presets: presetValues(card), title: card.dataset.title, variant: option.textContent.trim(), image: image ? image.currentSrc || image.src : '', quantity: 0, inputs: [] };
        result.set(select.value, row);
      }
      row.quantity += quantity;
      row.inputs.push(input);
    });
    return result;
  }
  let reviewSources = new Map();
  function renderReview() {
    const list = document.querySelector('[data-b2b-review-list]');
    if (!list) return;
    const fragment = document.createDocumentFragment();
    reviewSources = selectionRows();
    reviewSources.forEach(row => {
      const item = document.createElement('li');
      if (row.image) {
        const image = document.createElement('img');
        image.src = row.image; image.alt = row.title; image.width = 60; image.height = 80;
        item.appendChild(image);
      }
      const detail = document.createElement('div');
      const title = document.createElement('strong'); title.textContent = row.title;
      const variant = document.createElement('p'); variant.textContent = row.variant;
      detail.append(title, variant);
      if (row.presets.length) detail.appendChild(presetGroup(row.presets, row.title));
      const label = document.createElement('label');
      const labelText = document.createElement('span'); labelText.textContent = 'Menge';
      const input = document.createElement('input');
      input.type = 'number'; input.min = '0'; input.step = '1'; input.value = String(row.quantity);
      input.inputMode = 'numeric'; input.dataset.b2bReviewQuantity = row.id;
      input.setAttribute('aria-label', 'Bestellmenge für ' + row.title); input.disabled = busy;
      label.append(labelText, input);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.textContent = 'Entfernen'; remove.dataset.b2bRemove = row.id;
      remove.setAttribute('aria-label', row.title + ' aus der Auswahl entfernen'); remove.disabled = busy;
      item.append(detail, label, remove); fragment.appendChild(item);
    });
    if (!fragment.childNodes.length) {
      const empty = document.createElement('li'); empty.textContent = 'Noch keine Produkte ausgewählt.'; fragment.appendChild(empty);
    }
    list.replaceChildren(fragment);
    refreshPresets();
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-b2b-review-open]');
    const close = event.target.closest('[data-b2b-review-close]');
    const remove = event.target.closest('[data-b2b-remove]');
    const dialog = document.querySelector('[data-b2b-review]');
    if (open && !open.disabled && dialog) { renderReview(); dialog.showModal(); }
    if (close && !busy && dialog) dialog.close();
    if (remove && !busy) {
      const row = selectionRows().get(remove.dataset.b2bRemove);
      if (row) row.inputs.forEach(input => { input.value = '0'; });
      message(''); refresh();
    }
  });
  document.addEventListener('input', event => {
    const input = event.target;
    if (!input.matches('[data-b2b-review-quantity]') || busy) return;
    const quantity = Number(input.value);
    if (!input.validity.valid || !Number.isSafeInteger(quantity) || quantity < 0) { refresh(false); return; }
    const row = reviewSources.get(input.dataset.b2bReviewQuantity);
    if (row) row.inputs.forEach((source, index) => { source.value = index === 0 ? String(quantity) : '0'; });
    message(''); refresh(false);
  });

  function refresh(renderList = true) {
    mountFeed();
    let total = 0;
    const review = document.querySelector('[data-b2b-review]');
    let valid = !review || !review.open || Array.from(review.querySelectorAll('[data-b2b-review-quantity]')).every(input => input.validity.valid && Number.isSafeInteger(Number(input.value)) && Number(input.value) >= 0);
    const variants = new Set();
    cards().forEach(card => {
      const input = card.querySelector('[data-b2b-quantity]');
      if (!input) return;
      const select = card.querySelector('[data-b2b-variant]');
      const option = select.selectedOptions[0];
      const quantity = Number(input.value);
      valid = valid && input.validity.valid && Number.isSafeInteger(quantity) && quantity >= 0;
      if (quantity > 0 && option && !option.disabled) { total += quantity; variants.add(select.value); }
      const min = Number(option.dataset.min) || 1;
      const step = Number(option.dataset.step) || 1;
      const max = Number(option.dataset.max) || 0;
      card.querySelector('[data-b2b-rule]').textContent = min > 1 || step > 1 || max
        ? 'Mindestmenge: ' + min + ' · Schritte: ' + step + (max ? ' · Max.: ' + max : '') : '';
      input.disabled = busy;
      select.disabled = busy;
    });
    bars().forEach(bar => {
      bar.querySelectorAll('[data-b2b-summary]').forEach(summary => { summary.textContent = total + ' Stück · ' + variants.size + ' Varianten ausgewählt'; });
      bar.querySelector('[data-b2b-review-open]').disabled = busy || uncertain || !valid || total === 0;
      bar.querySelectorAll('[data-b2b-review-close]').forEach(button => { button.disabled = busy; });
      const button = bar.querySelector('[data-b2b-add]');
      button.disabled = busy || uncertain || !valid || total === 0;
      button.textContent = busy ? 'Wird hinzugefügt …' : 'Alles bestätigen & in den Warenkorb';
    });
    if (renderList) renderReview();
    refreshPresets();
  }
  document.addEventListener('input', event => {
    if (event.target.matches('[data-b2b-quantity]')) { message(''); refresh(); }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-b2b-variant]')) { message(''); refresh(); }
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => setTimeout(refresh, 0));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-b2b-add]');
    if (!button || busy || uncertain || button.disabled) return;
    const bar = button.closest('[data-b2b-order-bar]');
    for (const input of document.querySelectorAll('[data-b2b-review-quantity]')) {
      if (!input.reportValidity() || !Number.isSafeInteger(Number(input.value))) return;
    }
    const entries = new Map();
    for (const card of cards()) {
      const input = card.querySelector('[data-b2b-quantity]');
      if (!input) continue;
      const quantity = Number(input.value);
      if (!input.reportValidity() || !Number.isSafeInteger(quantity) || quantity < 0) return;
      if (!quantity) continue;
      const select = card.querySelector('[data-b2b-variant]');
      const option = select.selectedOptions[0];
      if (!option || option.disabled) return;
      let entry = entries.get(select.value);
      if (!entry) {
        entry = { id: Number(select.value), quantity: 0, title: card.dataset.title,
          min: Number(option.dataset.min) || 1, step: Number(option.dataset.step) || 1,
          max: Number(option.dataset.max) || Infinity, inputs: [] };
        entries.set(select.value, entry);
      }
      entry.quantity += quantity;
      entry.inputs.push(input);
    }
    if (!entries.size) return;
    busy = true;
    message('');
    refresh();
    let before;
    let submitted = false;
    const cartURL = bar.dataset.cartUrl;
    const quantities = cart => {
      const result = new Map();
      cart.items.forEach(item => result.set(item.variant_id, (result.get(item.variant_id) || 0) + item.quantity));
      return result;
    };
    const readCart = async () => {
      const response = await fetch(cartURL + '.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Der Warenkorb konnte nicht geladen werden. Bitte erneut versuchen.');
      return quantities(await response.json());
    };
    try {
      before = await readCart();
      for (const entry of entries.values()) {
        const finalQuantity = (before.get(entry.id) || 0) + entry.quantity;
        if (finalQuantity < entry.min || finalQuantity > entry.max || finalQuantity % entry.step !== 0) {
          throw new Error(entry.title + ': Bitte die Mengenregel beachten (mindestens ' + entry.min + ', Schritte von ' + entry.step + (Number.isFinite(entry.max) ? ', maximal ' + entry.max : '') + '). Bereits im Warenkorb: ' + (before.get(entry.id) || 0) + '.');
        }
      }
      submitted = true;
      const response = await fetch(bar.dataset.addUrl, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: Array.from(entries.values(), entry => ({ id: entry.id, quantity: entry.quantity })) })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Ein Artikel konnte nicht hinzugefügt werden. Bitte die Verfügbarkeit prüfen.');
      entries.forEach(entry => entry.inputs.forEach(input => { input.value = '0'; }));
      uncertain = true;
      message('Die Auswahl wurde hinzugefügt. Der Warenkorb wird geöffnet …');
      window.location.assign(cartURL);
    } catch (error) {
      if (submitted) {
        // Shopify can add available stock even when returning an error. Reconcile
        // before retrying so a second click cannot add the successful items twice.
        try {
          const after = await readCart();
          entries.forEach(entry => {
            let added = Math.max(0, (after.get(entry.id) || 0) - (before.get(entry.id) || 0));
            entry.inputs.forEach(input => {
              const quantity = Number(input.value);
              const applied = Math.min(quantity, added);
              input.value = String(quantity - applied);
              added -= applied;
            });
          });
          message(error.message + ' Bereits übernommene Mengen wurden von der Auswahl abgezogen. Bitte den Warenkorb prüfen.');
        } catch (_) {
          uncertain = true;
          message('Der Warenkorbstatus konnte nicht bestätigt werden. Bitte zuerst „Warenkorb ansehen“ öffnen, um doppelte Mengen zu vermeiden.');
        }
      } else message(error.message);
    } finally {
      busy = false;
      refresh();
    }
  });
})();

  (function() {
    var sidebar = document.querySelector('[data-filter-sidebar]');
    var toggleBtn = document.querySelector('[data-filter-toggle-mobile]');
    var closeBtn = document.querySelector('[data-filter-close]');

    if (!sidebar || !toggleBtn) return;

    function openSidebar() {
      sidebar.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      sidebar.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    toggleBtn.addEventListener('click', openSidebar);

    if (closeBtn) {
      closeBtn.addEventListener('click', closeSidebar);
    }

    sidebar.addEventListener('click', function(e) {
      if (e.target === sidebar) {
        closeSidebar();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
        closeSidebar();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    /* Thumbnail click */
    var mainImage = document.querySelector('[data-product-main-image]');
    var thumbs = document.querySelectorAll('[data-product-thumbnail]');

    if (mainImage && thumbs.length > 0) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var newSrc = this.dataset.productThumbnail;
          var newSrcset = this.dataset.srcset;

          mainImage.src = newSrc;
          if (newSrcset) mainImage.srcset = newSrcset;
          var thumbImage = this.querySelector('img');
          if (thumbImage) mainImage.alt = thumbImage.alt;

          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          this.classList.add('is-active');
        });
      });
    }

    /* Quantity buttons */
    var minusBtn = document.querySelector('[data-quantity-minus]');
    var plusBtn = document.querySelector('[data-quantity-plus]');
    var qtyInput = document.querySelector('.product-page__qty-input');

    if (minusBtn && plusBtn && qtyInput) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
      plusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        var max = parseInt(qtyInput.max, 10) || 99;
        if (val < max) qtyInput.value = val + 1;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-product-recommendations]');
    if (!section) return;

    var url = section.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function(response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-product-recommendations]');
        if (fresh && fresh.innerHTML.trim().length > 0) {
          section.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function() {});
  })();

  } catch(e) { console.error(e); }
})();
})();
